import { AxiosTransformer } from "axios";

function toArray<T>(value: T | T[] | undefined) {
  if (Array.isArray(value)) {
    return value;
  }

  return value ? [value] : [];
}

export function buildTransformers(
  ...values: Array<AxiosTransformer | AxiosTransformer[] | undefined>
): AxiosTransformer[] {
  return values.map(toArray).reduce((result, array) => {
    result.push(...array);

    return result;
  }, []);
}
